<template>
  <div class="payment-method-list">
    <h4 class="payment-method-list__title">Payment Method</h4>
    <div v-if="paymentMethodOnFile" class="payment-method-list__wrapper">
      <PaymentMethodListExistingItem
        @existing-payment-clicked="handleExistingPaymentMethod"
        @replace-payment-clicked="handleReplaceMethod"
      />
    </div>
    <div v-else class="payment-method-list__wrapper">
      <PaymentMethodListItems />
    </div>
    <div class="payment-method-list__cta-wrapper" v-if="paymentMethodOnFile">
      <PaymentMethodListWarning showCTAWarning v-if="isWarningModalShown" />
      <button
        v-if="recurlyToken.length === 0 || recurlyToken === ''"
        @click="handleMethod"
        class="btn btn--primary"
      >
        Continue
      </button>
      <router-link
        v-else
        :to="{ name: 'confirmation' }"
        :disabled="recurlyToken.length === 0"
        class="btn btn--primary"
      >
        Continue
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import { eventsConstants } from '@/helpers/eventsList'
import PaymentMethodListExistingItem from '@/components/payment/method-list/PaymentMethodListExistingItem.vue'
import PaymentMethodListWarning from '@/components/payment/method-list/PaymentMethodListWarning.vue'
import PaymentMethodListItems from '@/components/payment/method-list/PaymentMethodListItems.vue'
import { mixpanelEvent } from '@/helpers/mixins'

export default {
  name: 'PaymentMethodList',
  mixins: [mixpanelEvent],
  components: {
    PaymentMethodListWarning,
    PaymentMethodListExistingItem,
    PaymentMethodListItems,
  },
  data() {
    return {
      isWarningModalShown: false,
      selectedMethodText: '',
    }
  },
  computed: {
    ...mapState({
      paymentMethod: state => state.subscriptions.paymentMethod,
      paymentMethodOnFile: state => state.subscriptions.paymentMethodOnFile,
      isPaymentModalShown: state => state.app.isPaymentModalShown,
      isAuthenticated: state => state.auth.isAuthenticated,
    }),
    ...mapGetters({
      recurlyToken: 'recurly/getRecurlyToken',
    }),
    last4Digits() {
      const { payment_method_mask } = this.paymentMethodOnFile
      return payment_method_mask || ''
    },
    paymentOnFileType() {
      const { payment_method_object } = this.paymentMethodOnFile
      return payment_method_object || 'credit_card'
    },
  },
  methods: {
    ...mapMutations({
      setIsPaymentFormShown: 'app/IS_PAYMENT_MODAL_SHOWN_UPDATED',
      setIsPaymentSelectorModalShown: 'app/IS_PAYMENT_SELECTOR_MODAL_SHOWN_UPDATED',
    }),
    handleExistingPaymentMethod() {
      this.isWarningModalShown = false
      this.selectedMethodText =
        this.paymentOnFileType === 'credit_card'
          ? `Pay with card ending in ${this.last4Digits}`
          : 'Pay with recently used PayPal account'
      this.$store.dispatch(
        'subscriptions/setPaymentMethod',
        this.paymentOnFileType === 'credit_card' ? 'card' : 'paypal'
      )
      this.$store.dispatch('recurly/setRecurlyToken', 'existing_payment_method')
    },
    handleReplaceMethod() {
      this.selectedMethodText = 'Replace payment method'
      this.isWarningModalShown = true
      this.$store.dispatch('recurly/setRecurlyToken', '')
      this.$store.dispatch('subscriptions/setPaymentMethod', '')
    },
    handleMethod() {
      this.$store.dispatch('recurly/setRecurlyToken', '')
      if (this.paymentMethod === '') {
        this.setIsPaymentSelectorModalShown(true)
      } else {
        if (this.isAuthenticated) {
          this.sendMixpanelEvent(eventsConstants.CHECKOUT_CART_UPDATED, {
            trigger: 'paymentMethodFormShown',
          })
        }
        this.setIsPaymentFormShown(true)
      }
    },
  },
  watch: {
    isPaymentModalShown(value) {
      this.isWarningModalShown = false
      this.$store.dispatch('app/setIsComponentLoading', false)
    },
  },
}
</script>

<style lang="scss">
.payment-method-list {
  border-radius: 35px;
  @include mobile {
    border-radius: 10px;
    background: transparent;
    border-radius: unset;
    padding: 0;
    height: 100%;
  }
  @include desktop {
    display: grid;
    grid-template-rows: 60px 40% auto;
  }
  &__title {
    color: var(--white);
    font-family: var(--font-regular);
    font-weight: 450;
    font-size: 24px;
    line-height: 32px;
    margin: 10px 0 15px 0;
    @include tablet {
      margin: 40px 0px;
    }
    @include desktop {
      font-weight: 450;
      font-size: rem(24);
      line-height: 32px;
      margin: 0;
      margin-bottom: 50px;
    }
  }
  &__wrapper {
    display: flex;
  }
  &__cta-wrapper {
    display: flex;
    justify-content: flex-end;
    flex-flow: column;
    width: 100%;
    @include desktop {
      flex-flow: row;
      align-items: end;
    }
    .btn {
      text-decoration: none;
      width: 100%;
      @include desktop {
        width: unset;
      }
    }
  }
}
</style>
